export const TOTALSALES = {
  TOTALSALESLISTS: 'total_sales_lists',
  SUMSALESLISTS: 'sum_sales_lists',
  VANCANCELSTATUS: 'van_cancel_status',
};
